import Banner from 'components/banner/Banner';
import Navigation from 'components/Navigation';
import Form from 'components/form/Form';

function App() {
	return (
		<>
			<Navigation />
			<Banner />
			<Form />
		</>
	);
}

export default App;
